import styled from 'styled-components';
import tw from 'twin.macro';
import { Modal } from '../../modal';
import { Button } from '../../button';

const Message = styled.p`
  ${tw`text-base text-text-secondary leading-relaxed mb-6`}
`;

const Actions = styled.div`
  ${tw`flex flex-col sm:flex-row gap-3 justify-center w-full`}
`;

interface DynamicPricingConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DynamicPricingConfirmModal: React.FC<DynamicPricingConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      modalWidth="min(480px, calc(100vw - 2rem))"
      contentAlign="center"
    >
      <Message>
        You are trying to set dynamic pricing for all days after today. If you have already selected
        dates we are going to deselect them and then you can set the dynamic pricing for all future
        days.
      </Message>
      <Actions>
        <Button text="Cancel" theme="outlined" onClick={onCancel} buttonWidth="100%" />
        <Button text="Continue" onClick={onConfirm} buttonWidth="100%" />
      </Actions>
    </Modal>
  );
};

export default DynamicPricingConfirmModal;
